export default __webpack_public_path__ + "static/media/automation-full-linux.20fada37.avif";